import planera from '../imgs/planera.png'
import futbase from '../imgs/futbase.png'
import futbaseControle from '../imgs/futbaseControle.png'
import videoNotes from '../imgs/videoNotes.png'
import logo from '../imgs/logo.svg'
export const portfolio=[
    {
      nome:"Video Notes",
      link:"videonotes.com.br",
      texto:`Website para visualizar e criar notas de tempo em cima de vídeos do Youtube. As notas levam diretamente ao segundo exato do vídeo, facilitando assim o estudo autodidata.`,
      img:videoNotes
    },
    {
      nome:"FutBase",
      link:"futbase.vercel.app",
      texto:`Central de estatísticas das maiores ligas de futebol, com grande complexidade de dados e facilitação de visualização.`,
      img:futbase
    },
    {
      nome:"Futbase - Controle",
      link:"futbase-controle.vercel.app",
      texto:`Central de controle para atualizar os resultados, evitando assim o uso de uma api que envolva custos. Todas as informações foram programadas para gerar o mínimo de cliques e digitação possível`,
      img:futbaseControle
    },
    {
      nome:"Planera",
      link:"planera.vercel.app",
      texto:`Planer gráfico para organizar os compromissos da semana.`,
      img:planera
    },
  
  ]